// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgQuotationMarks: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M7.713 3.826c-.699-.568-1.7-.607-2.388-.027C2.022 6.584 0 10.285 0 14.493c0 4.181 2.75 6.644 5.842 6.644 2.864 0 5.27-2.406 5.27-5.327 0-2.807-2.005-4.697-4.41-4.697-.595 0-1.088-.531-.8-1.051.455-.82 1.109-1.642 1.829-2.36C8.76 6.678 8.918 4.806 7.79 3.89zm12.888 0c-.699-.568-1.7-.607-2.388-.027-3.303 2.785-5.325 6.486-5.325 10.694 0 4.181 2.807 6.644 5.9 6.644 2.806 0 5.212-2.406 5.212-5.327 0-2.807-1.948-4.697-4.41-4.697-.586 0-1.07-.534-.782-1.044.46-.818 1.108-1.639 1.819-2.356 1.023-1.032 1.178-2.908.05-3.824z" />
      </g>
    </svg>
  );
};

const Memo = memo(SvgQuotationMarks);
export default Memo;
